import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { activityApi } from "../../entities/Activity/activityApi";
import authReducer from "../../entities/Auth/authApi";
import { courseApi } from "../../entities/Course/courseApi";
import courseReducer from "../../entities/Course/courseApi";
import { lessonApi } from "../../entities/Lesson/lessonApi";
import { openaiApi } from "../../entities/OpenAI/openAIapi";
import { speakingFeedbackApi } from "../../entities/SpeakingFeedback/speakingFeedbackApi";
import { usersApi } from "../../entities/User/userApi";

const rootReducer = combineReducers({
	[lessonApi.reducerPath]: lessonApi.reducer,
	[activityApi.reducerPath]: activityApi.reducer,
	[usersApi.reducerPath]: usersApi.reducer,
	[courseApi.reducerPath]: courseApi.reducer,
	[openaiApi.reducerPath]: openaiApi.reducer,
	[speakingFeedbackApi.reducerPath]: speakingFeedbackApi.reducer,
	auth: authReducer,
	courseStore: courseReducer,
});

const persistConfig = {
	key: "root",
	storage,
	whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: ["persist/PERSIST"],
			},
		}).concat(
			lessonApi.middleware,
			activityApi.middleware,
			usersApi.middleware,
			courseApi.middleware,
			openaiApi.middleware,
			speakingFeedbackApi.middleware,
		),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
